module.exports = __webpack_public_path__ + "static/media/Classic King.cb1850b8.jpg";